export const GET_MATERIAL = 'material/material-form-start';
export const GET_MATERIAL_ERROR = 'material/material-form-error';
export const MATERIAL_CLEAR = 'material/material-form-clear';
export const MATERIAL_SINGLE_SUCCESS = 'material/material-single-success';
export const MATERIAL_UPDATE_SUCCESS = 'material/material-update-success';
export const MATERIAL_CREATE_SUCCESS = 'material/material-create-success';
export const MATERIAL_AUDIT = 'material/audit';
